
<div class="lcs-main-container">
  <div class="message">
    <h1>Logging in...</h1>
  </div>
</div>
